const courtHearings = {
  title: "Tagsatzungen",
  filter: {
    from: "Zeitraum von",
    to: "Zeitraum bis",
    court: "Gericht",
    counselor: "Berater:in",
    groupingAriaLabel: "Gruppierung auswählen",
    validation: {
      toBeforeFrom: "„Zeitraum bis“ darf nicht vor „Zeitraum von“ liegen.",
      rangeTooLong: "Der Zeitraum darf höchstens ein Jahr umfassen.",
    },
  },
  grouping: {
    byDate: "nach Datum",
    byCourt: "nach Gericht",
  },
  report: {
    loading: "Tagsatzungen werden geladen",
    error: "Die Tagsatzungen konnten nicht geladen werden. Bitte später erneut versuchen.",
    empty: "Keine Tagsatzungen im gewählten Zeitraum.",
    noCourt: "Kein Gericht zugeordnet",
    courtNumber: "Gericht-Nr. {{shortCode}}",
    notAssigned: "nicht eingeteilt",
  },
  columns: {
    time: "Uhrzeit",
    clientName: "Kundenname",
    caseNumber: "Kunden-Nr.",
    dutyCounselor: "Berater (Dienst)",
    fileNumber: "Aktenzahl",
  },
};

export default courtHearings;
